module.exports = __webpack_public_path__ + "static/snowball-app-trade-6b4f5958e47081bfbfa7f1ca77820a0c.png";